import type { FaireProductEntity } from "../../entity_types/product";

export const p_m8ybpjvqmq: FaireProductEntity = {
  token: "p_m8ybpjvqmq",
  type: "product",
  name: "Gold Silver Plated zircon inlaid Sparkling Pave Dome Ring",
  brandToken: "b_6hzxpxjqta",
  brandName: "Sparkling Extras",
  imageUrl:
    "https://cdn.faire.com/fastly/72e03ee99be73e1f9d2fd6b85ac72e5b8b809619f4bf2b42b4290b52baf1e40c.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1ac41a19f133d5a067670a73bf00f4b632aafed7baf12af0b48fa66f36f3ac22.jpeg",
    "https://cdn.faire.com/fastly/96a95c5bae52d5aa3bd5384cc8fd86b1201d6b0157645732cfc49e91ea3a0fea.jpeg",
    "https://cdn.faire.com/fastly/318b5c96f7f87b2ab2431d6eedb9d67ccf3917eb13c6cf4d43bdaf78c45cb640.webp",
    "https://cdn.faire.com/fastly/1fbd80c9509b6ba3b5729d7ea0d86c4759443ab8d7ab9e67c27ce7407584478f.webp",
    "https://cdn.faire.com/fastly/84a80750fb2e9f84dbda08e0608775ebcc49c043a0610a1ab0110a1a71ebe83c.webp",
    "https://cdn.faire.com/fastly/fc52104dc13b9feeb063dce4a1ce013605445d6ee36329c2484a46e06becd810.webp",
    "https://cdn.faire.com/fastly/24b1d1c4a93b3d07c4887f932ac89b7b843ee3ab93a7d8eade6e13fd964204a4.webp",
  ],
  priceDollars: 6.99,
  description:
    "Material：Titanium steel\nColor：Gold/Silver\nProcess：Pave cublic\nStone style: Czech diamond\nComfortable to wear and versatile enough to pair with a variety of outfits, this encrusted ring is an investment piece that will never go out of style. ",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:06.211Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
